export default __webpack_public_path__ + "static/media/cover3.d18de1db.jpg";